import SnackbarComponent from "components/SnackBar"
import { useEffect, useState } from "react"
import Header from "./Header"
import CreateDoctorModal from "./CreateDoctorModal"
import axios from "axios"
import config from "config/config"
import { useSelector } from "react-redux"
import DoctorCard from "./DoctorCard"
import { Col, Row } from "reactstrap"

export const Doctors = () => {
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const [err, setErr] = useState(false)
  const [success, setSuccess] = useState(false)
  const [createModalOpen, setCreateModalOpen] = useState(false)
  const [doctors, setDoctors] = useState([])
  const [loading, setLoading] = useState(false)
  const userData = useSelector(state => state.Login.userData)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const handleCreateNewDoctor = async doctor => {
    setLoading(true)
    let response

    try {
      response = await axios.post(
        `${config.backendUrl}/doctors`,
        { doctor },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
    } catch (err) {
      console.log("Error", err)
      if (err.status === 403) {
        setErr(err.response.data.message)
      } else {
        setErr("Error adding doctor")
      }
    } finally {
      if (response.status === 200) {
        setCreateModalOpen(false)
        setSuccess("Doctor added successfully")
      }
      setLoading(false)
      fetchDoctors()
    }
  }

  const fetchDoctors = async () => {
    setLoading(true)
    let response
    try {
      const response = await axios.get(
        `${config.backendUrl}/doctors?orgId=${
          isConsolidatedView
            ? organizations.map(org => org.Organization.id).join(",")
            : activeOrganization.id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setDoctors(response.data.doctors)
    } catch (err) {
      setErr("Error fetching doctors.")
      console.log("Error fetching doctors", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (
      activeOrganization.id ||
      isConsolidatedView ||
      organizations.length > 0
    ) {
      fetchDoctors()
    }
  }, [activeOrganization.id, isConsolidatedView, organizations])
  return (
    <>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <CreateDoctorModal
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSave={handleCreateNewDoctor}
        loading={loading}
      />
      <Header onCreateNew={() => setCreateModalOpen(true)} />
      <Row className="g-3 align-items-stretch">
        {doctors.length > 0 &&
          doctors.map((doctor, index) => (
            <Col xs={12} md={6} lg={3} key={index} className="d-flex">
              <DoctorCard doctor={doctor} />
            </Col>
          ))}
      </Row>
    </>
  )
}
